<template>
  <template-layout :breadCrumbList="breadcrumbComputed">
    <div class="py-12 px-4">
      <nav class="flex justify-between items-center mb-4">
        <h1 class="text-2xl text-theme-1">
          ครอบครัว
        </h1>
        <AddFamilyModal :addFamilyModal="addFamilyModal" @modal-value="clearValue"/>
      </nav>
      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-12 md:col-span-4 lg:col-span-3" v-if="getAllowActionByCurrRole('search-family')">
          <FamilyFilter />
        </div>
        <div class="col-span-12" :class="{'md:col-span-8 lg:col-span-9': getAllowActionByCurrRole('search-family')}">
          <FilterSummary :items="filterSummaryStore" v-if="getAllowActionByCurrRole('search-family')" />
          <FamilyDatatable :filter="filterValue" />
        </div>
      </div>
    </div>
  </template-layout>
</template>

<script setup>
import AddFamilyModal from "@/components/add-family-modal";
import FamilyFilter from "@/components/filter-search/FamilyFilter.vue";
import FilterSummary from "@/components/filter-summary/index.vue";
import FamilyDatatable from "./Datatable.vue"
import { useStore } from "vuex";
import { ref, computed, watch,reactive } from "vue";
import TemplateLayout from "@/layouts/side-menu/Main.vue"
import { getAllowActionByCurrRole } from "@/utils/get-roles"

const store = useStore();
const filterSummaryStore = computed(
  () => store.getters["familyFilter/getFilterSummaryArray"]
);
const filterValue = computed(() => store.getters["familyFilter/getFilterForApi"]);
const addFamilyModal = ref(false);

const openAddFamilyModal = (val) => {
  addFamilyModal.value = val
};
const clearValue = (val) => {
  addFamilyModal.value = val
};
const breadcrumbComputed = reactive([{
  name: "ครอบครัว",
  active: true
}])
</script>
<style lang="scss">
.tabulator {
  .tabulator-headers{
    background:#214181;
    color: #FFF;
    font-weight: bold;
  }
}
</style>
